<h2 class="content-block"><i class="fa fa-user"></i> Kullanıcı Listesi</h2>
<div class="container">
    <dx-data-grid
    id="gridContainer"
    [dataSource]="users"
    keyExpr="id"
    class="content-block card responsive-paddings"
    [allowColumnReordering]="true"
    [showBorders]="true"
    (onRowInserting)="create($event)"
    (onRowUpdating)="update($event)"
    (onRowRemoved)="delete($event)"
  >
    <!-- (onSaving)="update($event)" -->
    <dxo-paging [enabled]="true"></dxo-paging>
    <dxo-editing
      mode="row"
      [allowUpdating]="true"
      [allowDeleting]="true"
      [allowAdding]="true"
    >
    </dxo-editing>
    <dxo-export [enabled]="false"></dxo-export>
    <dxi-column dataField="name" caption="İsim" aria-required="true">
      <dxi-validation-rule
        type="required"
        message="Name is required"
      ></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="email">
      <dxi-validation-rule
        type="required"
        message="Email is required"
      ></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="userType" caption="Kullanıcı Tipi">
      <dxo-lookup
        [dataSource]="userTypes"
        valueExpr="id"
        displayExpr="name"
      ></dxo-lookup>

      <dxi-validation-rule
        type="required"
        message="required"
      ></dxi-validation-rule>
    </dxi-column>
    <dxi-column type="buttons" [width]="110">
      <dxi-button name="edit"></dxi-button>
      <dxi-button name="delete"></dxi-button>
      <dxi-button
        hint="Şifreyi yenile"
        icon="lock"
        [onClick]="renewPassword"
      ></dxi-button>
    </dxi-column>
  </dx-data-grid>
</div>
